module.exports = __webpack_public_path__ + "img/red-uploader-icon.5bb0da4a.svg";